import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {parseQueryParams} from "../../../utils/url";
import Popup from '../../../components/Popup';
import Block from './Block';

class OrderDetails extends React.Component {

  state = {
    popupData: null,
  };

  componentWillMount() {
    this.props.getUserOrder({orderId: this.props.match.params.id});
    const qp = parseQueryParams(this.props.history.location.search);
    if (qp && qp.pay && qp.pay === 'success') {
      this.setState({
        popupData: {
          title: ('Payment was successful')
        }
      });
    }
  }

  getCityName = (arr, orderProducts) => {
    if (orderProducts && orderProducts[0] && orderProducts[0].tour && orderProducts[0].tour.cityId)
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === orderProducts[0].tour.cityId) {
          return arr[i].city
        }
      }
    return '';
  };

  closePopup = () => {
    this.props.cleanCart();
    this.setState({popupData: null}, () => {
      this.props.history.replace(this.props.history.location.pathname)
    })
  };

  render() {
    const {
      order,
      cities
    } = this.props;

    if (order) {
      const {
        createdAt,
        orderProducts,
        amount
      } = order;

      const {
        popupData
      } = this.state;
      return (
        <div className="booking__details">
          {
            popupData &&
            <Popup
              classPopup="success"
              classIcon="fa fa-smile-o"
              isShow={popupData && true}
              close={this.closePopup}
              {...popupData}
            />
          }
          <h2 className="booking__title">My Order</h2>
          <p className="booking__details-date">
            {moment(createdAt).locale('en').format('YYYY MMMM DD, hh:mm')}, {orderProducts[0] && this.getCityName(cities, orderProducts)}
          </p>
          <div>
            <ol className="booking__list">
              {
                orderProducts && orderProducts.map((op) => {
                  return (
                    <Block
                      key={`order-details-block-${op.productId}`}
                      {...op}
                    />
                  )
                })
              }
            </ol>
          </div>
          <div className="booking__address">
            <span className="booking__label">Pick up point:</span>
            <span className="booking__content">
              {orderProducts && orderProducts[0] ? orderProducts[0].meetingPlaceAddress : ''}
            </span>
          </div>
          <div className="booking__details-total">
            <p className="booking__item-group">
              <span className="booking__label">Total Price</span>
              <span className="booking__content"><span>$</span>{amount}</span>
            </p>
          </div>
        </div>
      )
    }
    return (
      <div className="booking__wait">
        <div className="booking__wait-block">
          <p className="booking__wait-title">Wait Pleas</p>
          <img src="/assets/img/wait.gif" alt="wait" />
        </div>
      </div>
    )
  }
}

OrderDetails.propTypes = {
  getUserOrder: PropTypes.func,
  match: PropTypes.object,
  order: PropTypes.object,
  cities: PropTypes.array,
  history: PropTypes.object,
  cleanCart: PropTypes.func,
};

export default OrderDetails


// WEBPACK FOOTER //
// ./src/app/containers/UserOrders/OrderDetails/Component.js